// <s-submit-guard> — prevents repeated submissions of the wrapped native form.
// After the first valid submit, the submit button is marked busy and further submits are ignored.
// The page reloads on submit (native Shopify contact form), so state resets automatically.
class SSubmitGuard extends HTMLElement {
  #ac = null;

  connectedCallback() {
    this.#ac = new AbortController();
    const form = this.querySelector("form");
    if (!form) return;

    form.addEventListener(
      "submit",
      (event) => {
        if (form.dataset.submitting === "true") {
          event.preventDefault();
          return;
        }
        form.dataset.submitting = "true";
        form.setAttribute("aria-busy", "true");
        const button = form.querySelector('[type="submit"]');
        if (button) {
          button.setAttribute("aria-disabled", "true");
          const busyLabel = this.dataset.busyLabel;
          if (busyLabel) button.textContent = busyLabel;
        }
      },
      { signal: this.#ac.signal },
    );
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }
}

if (!customElements.get("s-submit-guard")) {
  customElements.define("s-submit-guard", SSubmitGuard);
}
